// Caducidad (ms epoch) del claim `exp` de un JWT; null si no se puede leer.
// Sólo decodifica el payload: no verifica la firma (eso es cosa del backend).
export function jwtExpiraEn(token) {
  try {
    const payload = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const { exp } = JSON.parse(atob(payload));
    return typeof exp === "number" ? exp * 1000 : null;
  } catch {
    return null;
  }
}
